import { InjectionToken } from "@angular/core";

export const TraduccionesToken = new InjectionToken("TraduccionesToken");
